/**
 * One document of the index as text, for a part of a change page that renders
 * it. `null` while it loads; '' when it cannot be read (a file only in a pull
 * request has no row yet): the part then says so and links the file.
 */
import { useEffect, useState } from 'react';
import { docsApi } from '@/services/docsApi';

export function useDocText(docId: string | null | undefined): string | null {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    setText(null);
    if (!docId) {
      setText('');
      return;
    }
    docsApi.getDocContent(docId).then(
      (doc) => { if (live) setText(doc.content ?? ''); },
      () => { if (live) setText(''); },
    );
    return () => { live = false; };
  }, [docId]);

  return text;
}
